
export default [
  {path: '/documentos', component: () => import('./components/Main'), name: 'documentos.main', children: [
      {path: '', component: () => import('./components/Documentos'), name: 'documentos'}
    ]}
]
